// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"1f38ec9d","370":"876e4dd9","629":"69bb70be","637":"56fab8d6","651":"69bb70be"}[chunkId] + ".chunk.css";
};